import { render, staticRenderFns } from "./DownloadDialuxDataButton.vue?vue&type=template&id=1a1ad896"
import script from "./DownloadDialuxDataButton.vue?vue&type=script&lang=js"
export * from "./DownloadDialuxDataButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports